import { useEffect, useRef, useState } from "react";
import { SpreadToZoomIcon } from "frontend/icons/spred-to-zoom";
import SuccessAnimation from "frontend/canvas-onboarding/cim-onboarding/phases/device-selection/success-animation/success-animation";
import styles from "./navigation-step.module.css";
import { useAtomValue } from "jotai";
import { posScaleAtom } from "state-atoms";
import tracking from "frontend/tracking";

interface TrackpadZoomStepProps {
  name: string;
  completeStep: () => void;
}

export default function TrackpadZoomStep({ name, completeStep }: TrackpadZoomStepProps) {
  const posScale = useAtomValue(posScaleAtom);
  const [showSuccess, setShowSuccess] = useState(false);
  const currentScale = useRef<number>(posScale.scale);
  const hasCompletedRef = useRef(false);

  useEffect(() => {
    if (!hasCompletedRef.current && posScale.scale !== currentScale.current) {
      hasCompletedRef.current = true;
      currentScale.current = posScale.scale;

      setShowSuccess(true);
      tracking.trackAnalyticsEvent(`${name}_success`);
    }
  }, [posScale, name]);

  return (
    <SuccessAnimation showSuccess={showSuccess} successImage="hopa" onComplete={completeStep}>
      <div className={styles.trackpadStepsContainer}>
        <SpreadToZoomIcon />
      </div>
    </SuccessAnimation>
  );
}
